import type {
  FlowPropertiesGraphPanelInterface,
  FlowPropertiesPxxTablePanelInterface,
  FlowPropertiesSizeTablePanelInterface,
  InfoPanelInterface,
  ParticleSizeDistibutionGraphPanelInterface,
  ParticleSizeDistibutionListPanelInterface,
  WarningInterface,
  WarningPanelInterface,
} from 'gojs/panelData';

export const infoPanelVisible = (data: InfoPanelInterface) => {
  const allTexts = data.unitTextArray.flatMap((u) => u.texts);
  return allTexts.length > 0;
};

const hasWarning = (warnings: WarningInterface[]) => {
  return !!(warnings?.[0]?.warnings && warnings[0]?.warnings?.length > 0);
};

export const warningPanelVisible = ({
  majorWarnings,
  moderateWarnings,
  minorWarnings,
  hideNonMajorWarnings,
  unitDisplaySettings,
}: WarningPanelInterface) => {
  if (!unitDisplaySettings.warningText) {
    return false;
  }

  if (hasWarning(majorWarnings)) {
    return true;
  }

  if (!hideNonMajorWarnings) {
    return hasWarning(moderateWarnings) || hasWarning(minorWarnings);
  }
  return false;
};

export const flowPropertiesGraphVisible = ({
  flowPropertiesGraph,
}: FlowPropertiesGraphPanelInterface) => flowPropertiesGraph.display;

export const flowPropertiesSizeVisible = ({
  flowPropertiesSizeTable,
}: FlowPropertiesSizeTablePanelInterface) =>
  flowPropertiesSizeTable[0].data?.length > 0;

export const flowPropertiesPxxTableVisible = ({
  flowPropertiesPxxTable,
}: FlowPropertiesPxxTablePanelInterface) =>
  flowPropertiesPxxTable[0].data?.length > 0;

export const psdListVisible = ({
  tableData,
}: ParticleSizeDistibutionListPanelInterface) => !!tableData?.[0].display;

export const psdGraphVisible = ({
  flowPropertiesGraph,
}: ParticleSizeDistibutionGraphPanelInterface) => flowPropertiesGraph.display;
